export const state = {
  cfs: [],
  systemCfs: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/cfs/state.js